module.exports = __webpack_public_path__ + "img/resume.58bab6fe.jpg";